import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import FormConfig from '../../Config/FormConfig';
import dayjs from 'dayjs';
import { Formik } from 'formik';
import { Input, Row, Col, Button, DatePicker, Checkbox, Upload, Spin, message, InputNumber, Flex } from 'antd';
import { LoadingOutlined, InboxOutlined } from '@ant-design/icons';
import './ReferralContractCss.css';
import APIService from '../../Service/APIService';
import CustomHeader from '../CustomHeader/CustomHeader';
import Select from 'react-select';
import Swal from 'sweetalert2';
import {useAuth} from '../AuthProvider.js';
import { hasPermission } from '../../Config/permissions.js';

const NewDistributorReferralContract = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [userData, setUserData] = useState(user);
  const [isEditable, setIsEditable] = useState(true);
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [distributorOptions, setDistributorOptions] = useState([]);
  const [referreeDistributorOptions, setReferreeDistributorOptions] = useState([]);
  const [uploadContract, setUploadContract] = useState(null);
  const [uploadContractFileList, setUploadContractFileList] = useState([]);
  const [uploadContractFilename, setUploadContractFilename] = useState(null);
  const [existingReferralContract, setExistingReferralContract] = useState(null);
  const [allCommissionContracts, setAllCommissionContracts] = useState([]);
  const [uploadContractFileBlobName, setUploadContractFileBlobName] = useState(null);
  const navigate = useNavigate();

  const generateFieldsArray = (data = null) => {
    const fields = FormConfig.NewDistributorReferralContract;
    // console.log(accountFields);
    // setFieldsArr(fields);
    const val = generateInitialValues(fields, data);
    console.log("Createedby ", val["CreatedBy"]);
    val["CreatedBy"] = (id !== null && id !== undefined) ? val["CreatedBy"] : userData.FirstName + " " + userData.LastName;
    val["CreatedByEmail"] = userData?.Email;

    // if (location.state && location.state.type === "Duplicate") {
    //   // add one day to end date and save in start date
    //   val["StartDate"] = dayjs(val["EndDate"]).add(1, 'days').startOf('day');
    //   val["EndDate"] = null;
    //   val["IsEnded"] = false;
    // }
    // else{
    val["StartDate"] = val["StartDate"] === null ? null : dayjs(val["StartDate"]);
    val["EndDate"] = val["EndDate"] === null ? null : dayjs(val["EndDate"]);
    val["IsEnded"] = val["IsEnded"] === null ? false : val["IsEnded"];
    // }
    console.log('Initial Values:', val);
    console.log("Createedby ", val["CreatedBy"]);
    setInitialValues(val);
    return val;
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] = cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    return obj;
  }

  const getDistributorOptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend('getdistributors');
    // console.log("Distributors: ", response);
    let tempOptions = [];
    response?.data?.data.map((ele) => {
      tempOptions.push({
        value: ele.ID,
        label: ele.DistributorName
      });
    });
    setDistributorOptions(tempOptions);
    setReferreeDistributorOptions(tempOptions);
    return tempOptions;
  }

  const getContractData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getdistributorreferralcontractbyid?ID=${id}`);
    console.log("ManufacturerContract: ", response);
    setExistingReferralContract(response?.data?.data?.DistributorReferralContract);

    if (response?.data?.data?.DistributorReferralContract?.UploadContract) {
      // const arrayBuffer = response?.data?.data?.DistributorReferralContract?.UploadContract.data;
      // const bytes = new Uint8Array(arrayBuffer);
      // const blob = new Blob([bytes], { type: "application/pdf" });
      const filename = response?.data?.data?.DistributorReferralContract?.UploadContractFilename ? response?.data?.data?.DistributorReferralContract?.UploadContractFilename : "uploadcontract.pdf";
      setUploadContractFileList([{ name: filename, status: 'done', uid: '1' }]);
      // setUploadContract(blob);
      setUploadContractFileBlobName(response?.data?.data?.DistributorReferralContract?.AzureBlobName);
      setUploadContractFilename(filename);
    }

    generateFieldsArray(response?.data?.data?.DistributorReferralContract);
    setIsEditable(false);
    return response?.data?.data?.DistributorReferralContract;
  }

  useEffect(() => {
    // Your code here
    console.log("DistributorReferralContract.js", id);
    if (userData && userData.Type === "Account") {
      navigate(`/Account/${userData.AccountID}`);
      window.location.reload();
    } else if (userData && userData.Type === "Distributor") {
      navigate(`/Distributor/${userData.DistributorID}`);
      window.location.reload();
    }
    else if (
      userData &&
      !hasPermission(
        userData,
        id ? "dist_contract.view" : "dist_contract.edit"
      )
    ) {
      navigate('/');
      window.location.reload();
    }
    // generateFieldsArray();
    let val = null;
    if (id) {
      getDistributorOptions();
      getContractData().then((data) => {
        if (userData.Type === "Distributor") {
          if (data.DistributorID != userData.DistributorID) {
            window.location.href = `/Distributor/${userData.DistributorID}`;
          }
        }
        setLoading(false);
      });
    }
    else {
      if (userData.Type !== "Admin") {
        window.location.href = "/";
      }
      val = generateFieldsArray(null);
      setIsEditable(true);
      getDistributorOptions().then(() => {
        setLoading(false);
      });
    }
  }, [id]);

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadContractFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    // download the file from Azure Blob Storage
    const link = document.createElement('a');
    link.href = sasUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // const link = document.createElement("a");
    // let url = null;
    // console.log("Uploaded Contract: ", uploadContract);
    // url = window.URL.createObjectURL(uploadContract);
    // link.href = url;
    // link.setAttribute("download", uploadContractFilename); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: ['.pdf'],
    // customRequest:  handleFile,
    disabled: !isEditable,
    onChange(info) {
      const { status } = info.file;
      // set limit of 4mb on file size and throw error
      // if (info.file.size > 4194304) {
      //   message.error(`${info.file.name} is too large, please select a file less than 4MB`);
      //   return;
      // }
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const handleFile = async ({ file, onSuccess }) => {
    // setIvrReport(file);
    if (file.size > 4194304) {
      message.error(`${file.name} is too large, please select a file less than 4MB`);
      return;
    }
    setUploadContract(file);
    setUploadContractFilename(file.name);
    setUploadContractFileList([{ name: file.name, status: 'done', uid: '1' }]);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }

  const submitHandler = async (values) => {
    console.log("Values: ", values);
    values.UploadContractFilename = uploadContractFilename;
    setLoading(true);
    // start date should be less than end date
    if (values.StartDate && values.EndDate) {
      if (values.StartDate.isAfter(values.EndDate)) {
        setLoading(false);
        message.error("Start date should be less than end date");
        return;
      }
    }

    if (values.IsEnded && values.EndDate === null) {
      setLoading(false);
      message.error("Please select end date");
      return;
    }
    console.log("DistReferralContract working:");

    // return;
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then(async (result) => {
      if (result.isConfirmed) {

        const postObj = {
          DistributorReferralContract: values,
        };
        const apiServe = new APIService();
        let formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("files", uploadContract);
        console.log("FormData: ", formData);
        let url = null;
        if (id !== null && id !== undefined) {
          url = `updatedistributorreferralcontract?ID=${id}`;
        }
        else {
          url = `createdistributorreferralcontract`;
        }
        console.log("URL: ", url);
        const response = await apiServe.addFileDataToBackend(formData, url, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log("Response: ", response);
        if (response?.status === 200) {
          Swal.fire({
            title: 'Success!',
            text: response?.data?.message,
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            window.location.href = '/Distributor/' + values.DistributorID;
          });
        }
        else {
          Swal.fire({
            title: 'Error!',
            text: response?.data?.message,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      }
      else {
        setLoading(false);
      }
    });
  }

  const handleButtonClick = (submitForm) => {
    if (isEditable) {
      submitForm(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  const getDistReferralContractOptions = async (distID) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`distreferralcontractoptions?DistID=${distID}`);
    console.log("Commission Options: ", response);
    setAllCommissionContracts(response?.data?.data?.ExistingReferralContracts);
    // remove the current dist id from the options
    const tempOptions = referreeDistributorOptions
    if (tempOptions && tempOptions.length > 0) {
      const options = tempOptions.filter((item) => item.value != distID);
      setReferreeDistributorOptions(options);
    }
  }

  const handleDeleteContract = async () => {
    console.log("delete contract");
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend({ ContractID: id }, "deletereferralcontractbyid");
        console.log("Response: ", response);
        if (response?.status === 200) {
          Swal.fire({
            title: 'Deleted!',
            text: "Referral Contract has been deleted.",
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            window.location.href = '/Distributor/' + existingReferralContract.DistributorID;
          });
        }
        else {
          setLoading(false);
          Swal.fire({
            title: 'Error!',
            text: response?.data?.message,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      }
    });
  }

  return (
    <div>
      {initialValues &&
        <CustomHeader leftTopText="Welcome back!"
          leftBottomText={id !== null && id !== undefined ? "Referral Contract" : "New Referral Contract"}
          rightTopText="Logged in as Admin"
          rightBottomText="User"
        />
      }
      {loading &&
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      }
      {initialValues && (
        <Formik onSubmit={submitHandler} initialValues={initialValues} >
          {(formik) => (
            // console.log("formik: ", formik),
            <form onSubmit={formik.handleSubmit}>
              {id !== null && id !== undefined &&
                <div>
                  {(hasPermission(userData, "dist_contract.edit") ||
                    hasPermission(userData, "dist_contract.delete")) &&
                    <div style={{ display: 'flex', gap: '16px', margin: '30px 0px 30px 0px' }}>
                      {hasPermission(userData, "dist_contract.edit") &&
                        <Button
                          type="primary"
                          style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
                          onClick={() => handleButtonClick(formik.handleSubmit)}
                        >
                          {isEditable ? 'Save Changes' : 'Edit'}
                        </Button>
                      }
                      {id && hasPermission(userData, "dist_contract.delete") &&
                        <Button
                          type="primary"
                          style={{ marginBottom: 16, background: 'red' }}
                          onClick={handleDeleteContract}
                        >
                          Delete
                        </Button>
                      }
                    </div>
                  }
                </div>
              }
              <div style={{ background: '#e3e3e3', borderRadius: '5px', padding: '0px 8px', marginBottom: '30px' }}>
                <p style={{ fontWeight: '600', fontSize: '18px', lineHeight: '36px' }}>Contract Details</p>
              </div>
              <Row gutter={16}>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Distributor Name <span style={{ color: 'red' }}>*</span></label>
                  <Select
                    onBlur={() => formik.setFieldTouched("DistributorID")}
                    // title={formik.values["AccountID"]}
                    value={{ label: formik.values["DistributorName"], value: formik.values["DistributorID"] }}
                    // onChange={async (value, option) => {
                    onChange={async (selectedOption) => {
                      console.log("Value: ", selectedOption.value);
                      console.log("Option: ", selectedOption);
                      formik.setFieldValue("DistributorName", selectedOption.label);
                      formik.setFieldValue("DistributorID", selectedOption.value);
                      getDistReferralContractOptions(selectedOption.value);
                    }}
                    style={{ width: '100%' }}
                    defaultValue=""
                    options={distributorOptions}
                    isDisabled={!isEditable}
                  />
                </Col>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Start Date<span style={{ color: 'red' }}>*</span></label>
                  <DatePicker
                    format="MM-DD-YYYY"
                    onBlur={() => formik.setFieldTouched("StartDate")}
                    title={formik.values["StartDate"]}
                    value={formik.values["StartDate"]}
                    onChange={(date, dateString) =>
                      formik.setFieldValue(
                        "StartDate",
                        date
                      )
                    }
                    style={{ width: '100%' }}
                    // disabledDate={(currentDate) => 
                    //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                    // }
                    // disabledDate={(currentDate) => {
                    //   const lastEndDate = allCommissionContracts?.reduce((latest, contract) => {
                    //     const contractEndDate = dayjs(contract?.EndDate);
                    //     return contractEndDate?.isAfter(latest) ? contractEndDate : latest;
                    //   }, dayjs(0)); // Initialize with the earliest possible date
                    //   return currentDate && (currentDate < lastEndDate?.add(1, 'days').startOf('day'));
                    // }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
                <Col span={2} style={{ width: '100%' }}>
                  <label className="form-label">Has End Date <span style={{ color: 'red' }}>*</span></label>
                  <Checkbox
                    name="IsEnded"
                    checked={formik.values.IsEnded}
                    onChange={(e) => {
                      formik.setFieldValue("IsEnded", e.target.checked);
                      if (e.target.checked) {
                        formik.setFieldValue("EndDate", dayjs());
                      }
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
                {formik.values.IsEnded &&
                  <Col span={6} style={{ width: '100%' }}>
                    <label className="form-label">End Date<span style={{ color: 'red' }}>*</span></label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("EndDate")}
                      title={formik.values["EndDate"]}
                      value={formik.values["EndDate"]}
                      onChange={(date, dateString) =>
                        formik.setFieldValue(
                          "EndDate",
                          date
                        )
                      }
                      style={{ width: '100%' }}
                      // disabledDate={(currentDate) => 
                      //   currentDate && (currentDate < dayjs().add(1, 'days').startOf('day') || currentDate.day() === 0)
                      // }
                      disabled={!isEditable}
                    />
                  </Col>
                }
                <Col span={4} style={{ width: '100%' }}>
                  <label className="form-label">Created By</label>
                  <Input
                    name="CreatedBy"
                    value={formik.values["CreatedBy"]}
                    defaultValue={formik.values["CreatedBy"]}
                    disabled
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Referee Distributor Name <span style={{ color: 'red' }}>*</span></label>
                  <Select
                    onBlur={() => formik.setFieldTouched("RefereeDistributorID")}
                    // title={formik.values["AccountID"]}
                    value={{ label: formik.values["RefereeDistributorName"], value: formik.values["RefereeDistributorID"] }}
                    // onChange={async (value, option) => {
                    onChange={async (selectedOption) => {
                      console.log("Value: ", selectedOption.value);
                      console.log("Option: ", selectedOption);
                      formik.setFieldValue("RefereeDistributorName", selectedOption.label);
                      formik.setFieldValue("RefereeDistributorID", selectedOption.value);
                    }}
                    style={{ width: '100%' }}
                    defaultValue=""
                    options={referreeDistributorOptions}
                    isDisabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />

                </Col>
                <Col span={6} style={{ width: '100%' }}>
                  <label className="form-label">Referral Commission %</label>
                  <Input
                    name="ReferralCommissionPercentage"
                    value={formik.values["ReferralCommissionPercentage"]}
                    defaultValue={formik.values["ReferralCommissionPercentage"]}
                    onBlur={() => formik.setFieldTouched("ReferralCommissionPercentage")}
                    onChange={formik.handleChange}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  />
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col span={24} style={{ width: '100%' }}>
                  <label className="form-label">Upload Contract</label>
                  <Upload.Dragger
                    {...uploadProps}
                    customRequest={({ file, onSuccess }) => handleFile({ file, onSuccess }, "UploadContract")}
                    onPreview={() => downloadFile("UploadContract")}
                    fileList={uploadContractFileList}
                    onRemove={() => {
                      setUploadContract(null);
                      setUploadContractFileList([]);
                      setUploadContractFilename(null);
                    }}
                    disabled={formik.values.DistributorID !== null ? !isEditable : true}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Drag or click to upload file</p>
                    <p className="ant-upload-hint">
                      Accepted format: PDF (Max file size limit: 4MB)
                    </p>
                  </Upload.Dragger>
                </Col>
              </Row>
              <div style={{ display: 'flex', justifyContent: 'end', padding: '0px 8px', margin: '80px 0px 20px 0px' }}>
                <Button onClick={formik.handleSubmit} type='primary' style={{ background: '#27a907', fontSize: '14px', fontWeight: '600' }}>Save Contract</Button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
}

export default NewDistributorReferralContract;
